<template>
  <v-container id="school" class="py-0" fluid>
    <v-skeleton-loader :loading="loading" transition-group="scale-transition" type="list-item-three-line">
      <v-row>
        <v-col cols="12"  xl="12" lg="12" md="12" sm="12" xs="12">
          <v-card class="mx-auto">
            <v-avatar tile color="grey lighten-1" height="150px" width="100%"><v-icon color="grey darken-2" x-large>mdi-office-building</v-icon></v-avatar>
            <v-card-title>{{ school.description }} {{ school.name }}</v-card-title>
            <v-card-subtitle>{{ school.address }}, {{ school.city }} ({{ school.district }}) &mdash; {{ school.postalCode }}</v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
    </v-skeleton-loader>

    <notify ref="refNotify"></notify>
  </v-container>
</template>

<script>
import NotifyVue from '../dialog/Notify.vue';
import apiRepository from '../../api/api-repository';

export default {
  name: 'SchoolView',

  components: {
    'notify': NotifyVue, // componente per la visualizzazione degli errori in snackbars.
  },

  data: ()=> ({
    loading: true, // gestione dello skeleton loader.
    school: new Object(), // oggetto della scuola dell'utente.
  }),

  methods: {
    async load(){
      try{
        let res = await apiRepository.school().find(); // attendo il risultato della chiamata.
        this.school = res.data; // carico il risultato sull'oggetto della scuola.
        this.loading = false; // disabilito lo skeleton loader.
      }
      catch(e){
        console.error(e); // loggo l'errore riscontrato.
        this.$refs.refNotify.notify('error', e.message); // notifico l'errore riscontrato nell'operazione.
      }
    }
  },

  created(){
    this.load(); // carico di dati della scuola alla creazione del componente.
  }
}
</script>